import psl from 'psl';

export const extractDomainInfo = (url) => {
  if (!url) return { hostname: url, hostnameWithoutTld: '', baseName: '', BaseNameFormatted: '' };

  try {
    const fullUrl = url.startsWith('http') || url.startsWith('https://') ? url : `http://${url}`;
    const { hostname } = new URL(fullUrl);
    const parsed = psl.parse(hostname);
    let hostnameFormatted = hostname.startsWith('www.') ? hostname.slice(4) : hostname;
    let hostnameWithoutTld = hostnameFormatted?.replace(new RegExp(`\\.${parsed.tld}$`, 'i'), '.*') || '';
    let baseNameFormatted = parsed.sld ? parsed.sld.charAt(0).toUpperCase() + parsed.sld.slice(1) : '';

    return {
      hostname: hostnameFormatted,
      hostnameWithoutTld,
      baseName: parsed?.sld?.toLowerCase() || '', // base du nom de domaine
      baseNameFormatted,
    };
  } catch (e) {
    return { hostname: url, hostnameWithoutTld: '', baseName: '', baseNameFormatted: '' };
  }
};

export const extractDomainName = (url) => {
  if (!url) return '';
  try {
    const checkedUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `http://${url}`;
    const domain = new URL(checkedUrl).hostname;
    return domain.startsWith('www.') ? domain.slice(4) : domain;
  } catch (e) {
    return url;
  }
};

export const checkSourceFromUrl = (url) => {
  // Check if the URL is empty or null
  if (!url) return { checked: false };
  
  try {
    const normalizedUrl = url.toLowerCase();

    if (normalizedUrl.includes('tiktok.com')) 
      return { checked: true, source: 'tiktok'};
    
    if (normalizedUrl.includes('youtube.com'))
      return { checked: true, source: 'youtube'};

    return { checked: false };
  } catch (error) {
    console.error("Erreur lors de l'analyse de l'URL:", error);
    return { checked: false };
  }
};